import { render, staticRenderFns } from "./person-filter-app.vue?vue&type=template&id=40b6cf86&"
import script from "./person-filter-app.vue?vue&type=script&lang=js&"
export * from "./person-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports